import React from 'react';
import { Text } from '@tamagui/core';
import { YStack } from '@tamagui/stacks';
import { MOCK_TRANSACTIONS } from '@/data/walletData';
import { FONT_SIZE_XL } from '../constants';
import TransactionItem from './TransactionItem';

export type HistoryTabProps = {
  isDark: boolean;
  textColor: string;
  subtextColor: string;
};

const HistoryTab: React.FC<HistoryTabProps> = React.memo(({
  isDark,
  textColor,
  subtextColor,
}) => {
  return (
    <YStack space="$3">
      <Text fontSize={FONT_SIZE_XL} fontWeight="700" color={textColor} paddingHorizontal="$2">
        Historia transakcji
      </Text>

      {MOCK_TRANSACTIONS.map((transaction, index) => (
        <TransactionItem
          key={transaction.id}
          transaction={transaction}
          isDark={isDark}
          textColor={textColor}
          subtextColor={subtextColor}
          isLast={index === MOCK_TRANSACTIONS.length - 1}
        />
      ))}
    </YStack>
  );
});

HistoryTab.displayName = 'HistoryTab';

export default HistoryTab;

